import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BdsButton from '../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import PrimaryHero from '../../../../shared/components/v3/Heros/PrimaryHero/PrimaryHero';
import { LOAD_BALANCE_ROUTE } from '../../../../shared/constants/auth';
import { CLICK_ACTION, LOAD_BALANCE } from '../../../../shared/constants/tagManager';
import { RewardsContext } from '../../../../shared/context/rewards/rewardsContext';
import tagManagerService from '../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_LOAD_BALANCE } from '../../../../shared/translations/rewards';
import { toLocaleNumberFormat } from '../../../../shared/utils/utils';

import './RewardsHero.scss';

interface RewardsHeroProps {
  title: string;
  showLoadBalanceButton?: boolean;
}

const RewardsHero = ({ title, showLoadBalanceButton = true }: RewardsHeroProps) => {
  const { balance, currency, loading, error } = useContext(RewardsContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToLoadBalance = () => {
    tagManagerService.pushEvent(CLICK_ACTION, LOAD_BALANCE);
    void navigate(LOAD_BALANCE_ROUTE);
  };

  return (
    <PrimaryHero
      title={title}
      color="hero-rewards"
      bottomContent={
        !loading &&
        !error && (
          <div className="rewards-hero-balance">
            <p className="balance-label m-0 whitespace-nowrap">{t(TRANSLATION_LOAD_BALANCE.header.card.title)}</p>
            <p className="balance-amount m-0 whitespace-nowrap">
              {toLocaleNumberFormat(Number.parseFloat(balance.toString()), { style: 'currency', currency: currency })}
            </p>
            {showLoadBalanceButton && (
              <BdsButton variant="primary" size="m" action={goToLoadBalance}>
                {t(TRANSLATION_LOAD_BALANCE.header.card.button)}
              </BdsButton>
            )}
          </div>
        )
      }
    />
  );
};

export default RewardsHero;
